const workouts = (state) => state.workouts;

export default workouts;
